import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['$state', '$scope', 'Util'];

class ChooseDeviceOsWizardController {

    constructor($state, $scope, Util) {

        this.$state = $state;
        this.$scope = $scope;
        this.Util = Util;

        this.deviceCategory = this.$scope.inputData.deviceCategory;

        if (this.deviceCategory === 'all') {

            this.supportedOs = ['windows', 'android', 'ios', 'osx'];

        } else if (this.deviceCategory === 'desktop') {

            this.supportedOs = ['windows', 'osx'];

        } else if (this.deviceCategory === 'mobile') {

            this.supportedOs = ['android', 'ios'];

        }

    }

    deployOn(os) {

        if (this.$state.current.name.indexOf('.home') > -1) {

            Mixpanel.send('ConnectWeb Add New Device Click', { Page: 'Homepage', 'Device Os': os });

            this.$scope.changeWizard()('root.dashboard.home.ltb.deploy', {
                os,
            }, {
                reload: false,
            });

        } else {

            Mixpanel.send('ConnectWeb Add New Device Click', { Page: 'My Devices', 'Device Os': os });

            this.$scope.changeWizard()('root.dashboard.devices.ltb.deploy', {
                os,
            }, {
                reload: false,
            });

        }

    }

}

class ChooseDeviceOsWizardDirective {

    constructor() {

        this.template = require('./choose-os-type-wizard.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $state,
            $scope, Util,
        ) =>
            new ChooseDeviceOsWizardController(
                $state,
                $scope, Util,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'chooseDeviceOsWizardCtrl';

    }

}

_directiveDependencies.push(() =>
    new ChooseDeviceOsWizardDirective());

angular.module('directives')
    .directive('chooseOsTypeWizard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/choose-os-type-wizard/choose-os-type-wizard.js